export default "__VITE_ASSET__67194ecd__"